import * as actionTypes from '../actions/widget/actionTypes';
import * as actions from '../actions';
import {put, takeEvery} from "@redux-saga/core/effects";

export function* loadWidgetSettings() {
    yield put(actions.getCompanyInfo());
    yield put(actions.loadLocale())
}

export const watchWidget = [
    takeEvery(actionTypes.LOAD_WIDGET_SETTINGS, loadWidgetSettings)
];